module.exports = __webpack_public_path__ + "img/shusong2.4769cfd9.png";